// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:where(.vuetify-styles) .v-sheet {
  display: block;
}
:where(.vuetify-styles) .v-sheet {
  border-color: rgba(var(--v-border-color), var(--v-border-opacity));
  border-style: solid;
  border-width: 0;
}
:where(.vuetify-styles) .v-sheet--border {
  border-width: thin;
  box-shadow: none;
}
:where(.vuetify-styles) .v-sheet {
  box-shadow: 0px 0px 0px 0px var(--v-shadow-key-umbra-opacity, rgba(0, 0, 0, 0.2)), 0px 0px 0px 0px var(--v-shadow-key-penumbra-opacity, rgba(0, 0, 0, 0.14)), 0px 0px 0px 0px var(--v-shadow-key-ambient-opacity, rgba(0, 0, 0, 0.12));
}
:where(.vuetify-styles) .v-sheet--absolute {
  position: absolute;
}
:where(.vuetify-styles) .v-sheet--fixed {
  position: fixed;
}
:where(.vuetify-styles) .v-sheet--relative {
  position: relative;
}
:where(.vuetify-styles) .v-sheet--sticky {
  position: sticky;
}
:where(.vuetify-styles) .v-sheet {
  border-radius: 0;
}
:where(.vuetify-styles) .v-sheet {
  background: rgb(var(--v-theme-surface));
  color: rgba(var(--v-theme-on-surface), var(--v-high-emphasis-opacity));
}
:where(.vuetify-styles) .v-sheet--rounded {
  border-radius: 4px;
}`, "",{"version":3,"sources":["webpack://./node_modules/vuetify/lib/components/VSheet/VSheet.css"],"names":[],"mappings":"AAAA;EACE,cAAc;AAChB;AACA;EACE,kEAAkE;EAClE,mBAAmB;EACnB,eAAe;AACjB;AACA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;AACA;EACE,sOAAsO;AACxO;AACA;EACE,kBAAkB;AACpB;AACA;EACE,eAAe;AACjB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,uCAAuC;EACvC,sEAAsE;AACxE;AACA;EACE,kBAAkB;AACpB","sourcesContent":[".v-sheet {\n  display: block;\n}\n.v-sheet {\n  border-color: rgba(var(--v-border-color), var(--v-border-opacity));\n  border-style: solid;\n  border-width: 0;\n}\n.v-sheet--border {\n  border-width: thin;\n  box-shadow: none;\n}\n.v-sheet {\n  box-shadow: 0px 0px 0px 0px var(--v-shadow-key-umbra-opacity, rgba(0, 0, 0, 0.2)), 0px 0px 0px 0px var(--v-shadow-key-penumbra-opacity, rgba(0, 0, 0, 0.14)), 0px 0px 0px 0px var(--v-shadow-key-ambient-opacity, rgba(0, 0, 0, 0.12));\n}\n.v-sheet--absolute {\n  position: absolute;\n}\n.v-sheet--fixed {\n  position: fixed;\n}\n.v-sheet--relative {\n  position: relative;\n}\n.v-sheet--sticky {\n  position: sticky;\n}\n.v-sheet {\n  border-radius: 0;\n}\n.v-sheet {\n  background: rgb(var(--v-theme-surface));\n  color: rgba(var(--v-theme-on-surface), var(--v-high-emphasis-opacity));\n}\n.v-sheet--rounded {\n  border-radius: 4px;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
